import React  from 'react';
function SilverZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Condition</th>
          <th > Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Obligation de Zakat	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        <tr >
          <td>Seuil de Zakat sur l'argent</td>
          <td>{result.silverWeightThreshold} (g) </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en espèces)</td>
          <td>{result.moneyZakatAmount} </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en argent)</td>
          <td>{result.silverZakatAmount} (g)</td>
        </tr>
      </tbody>
    </table>
  );
}
export default SilverZakatTable;
